/*
by zhou 2016/11/29
 */
'use strict';
angular.module('newTypeMgrModule', [])
    .controller('newTypeMgrCtrl', ['$scope', '$filter', '$modalInstance', 'modalDialog', 'trsHttpService', 'Params', 'trsspliceString', 'trsTransferService',
        function($scope, $filter, $modalInstance, modalDialog, trsHttpService, Params, trsspliceString, trsTransferService) {
            initStatus();

            /**
             * [initStatus description] 初始化状态 // 32
             *
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.Params = angular.copy(Params);
                $scope.data = {
                    queryStatus: [{ name: '启用', value: '1' }, { name: '禁用', value: '0' }], // 是否是核心稿库
                    queryHeXin: [{ name: '是', value: '1' }, { name: '否', value: '0' }], // 是否是核心类型
                    queryUGC: [{ name: '是', value: '1' }, { name: '否', value: '0' }], // 是否UGC使用
                    sortWeiZhiJson: [{ CATEGORYNAME: '最前面', CORDER: -1 }], // 调整位置时 最前面位置传-1
                    selectedLeftArray: [], // 左侧稿件可投稿人员范围 全选
                    selectedRightArray: [], // 右侧稿库可见范围 全选
                    Leftitems: [], // 左侧稿件可投稿人员范围 单选 请求返回数据
                    ownerTenantList: [], // 稿库可见范围本租户选中人员
                    tenantList: [], // 稿库可见范围选中的其它租户
                    Rightitems: [], // 右侧稿库可见范围 单选 请求返回数据
                    selectLeftTemp: [], // 临时保存 左侧稿件可投稿人员范围
                    selectRightTemp: [] // 临时保存 右侧稿库可见范围
                };
                var infoParams = {
                    serviceid: 'mlf_extuser',
                    methodname: 'getCurrUserInfo',
                };
                requestInfo(infoParams);
                for (var i = 0; i < Params.zuiqian.length; i++) {
                    if (Params.SHARECATEGORYID == Params.zuiqian[i].SHARECATEGORYID) {
                        Params.zuiqian.splice(i, 1);
                        $scope.Params.zuiqian.splice(i, 1);
                        $scope.data.selectIndex = i;
                        break;
                    }
                }
                $scope.data.sortWeiZhiJson = $scope.data.sortWeiZhiJson.concat(Params.zuiqian); // 在数组中添加选择对象最前面
                // 更改前一位置,保存相应数据
                for (var j = 0; j < $scope.data.sortWeiZhiJson.length; j++) {
                    var indexs = $scope.data.sortWeiZhiJson[j].CATEGORYNAME.indexOf(Params.CATEGORYNAME);
                    $scope.data.sortWeiZhiJson[j].name = $scope.data.sortWeiZhiJson[j].CATEGORYNAME;
                    $scope.data.sortWeiZhiJson[j].value = $scope.data.sortWeiZhiJson[j].CORDER;
                    // if (indexs > -1) {
                    //     $scope.data.sortWeiZhi = $scope.data.sortWeiZhiJson[j - 1];
                    // }
                }
                $scope.data.sortWeiZhi = $scope.data.sortWeiZhiJson[$scope.data.selectIndex];
                // 如果稿件是新建的,设置状态为启用,非核心稿库
                if ($scope.Params.SHARECATEGORYID === 0) {
                    $scope.Params.STATUS = $scope.data.queryStatus[0].value;
                    $scope.Params.ISCORE = $scope.data.queryHeXin[1].value;
                    $scope.Params.ISUGC = $scope.data.queryUGC[1].value;
                    $scope.data.sortWeiZhi = $scope.data.sortWeiZhiJson[0];
                } else {
                    // 修改时,请求数据的投稿人员
                    requestData();
                }
                $scope.title = $scope.Params.SHARECATEGORYID === 0 ? '添加稿库' : '修改稿库';
            }

            /**
             * [requestData description]请求数据 // 899
             *
             * @return  {[type]}  [return description]
             */
            function requestData() {
                var params = {
                    serviceid: 'mlf_sharedoc',
                    methodname: 'getShareCategory',
                    CatId: $scope.Params.SHARECATEGORYID
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get', true).then(function(data) {
                    $scope.Params.CORDER = data.CORDER;
                    $scope.Params.ISUGC = data.ISUGC;
                    $scope.data.Leftitems = data.TOUGAO;
                    $scope.data.Rightitems = data.CHAKAN;
                    angular.forEach(data.CHAKAN, function(item) {
                        if (item.OPERTYPE < 3) {
                            $scope.data.ownerTenantList.push(item);
                        } else {
                            $scope.data.tenantList.push(item);
                        }
                    });
                    if (data.TOUGAO.length === 1 && data.TOUGAO[0].OBJTYPE == 0) {
                        $scope.data.Leftitems = [];
                        $scope.data.Leftitems.push({
                            'OBJTYPE': 0,
                            'OBJID': 0, // $scope.info.GROUPID,
                            'OPERTYPE': 1,
                            'DESC': $scope.info.COMPANY
                        });
                    }
                    if (data.CHAKAN.length === 1 && data.CHAKAN[0].OBJTYPE == 0) {
                        $scope.data.Rightitems = [];
                        $scope.data.Rightitems.push({
                            'OBJTYPE': 0,
                            'OBJID': 0, // $scope.info.GROUPID,
                            'OPERTYPE': 2,
                            'DESC': $scope.info.COMPANY
                        });
                    }
                }, function(data) {
                    // console.log(data)
                });
            }

            /**
             * [requestInfo description]请求租户组织信息
             *
             * @param   {[type]}  paramsInfo  [paramsInfo description]
             *
             * @return  {[type]}              [return description]
             */
            function requestInfo(paramsInfo) {
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), paramsInfo, 'get').then(function(data) {
                    $scope.info = data;
                });
            }

            /**
             * [singleSelect description] 单选框
             * @param  {[type]} type [description] 类型
             * @param  {[type]} item [description] 选中的值
             * @return {[type]}      [description]
             */
            $scope.singleSelect = function(type, item) {
                $scope.Params[type] = item.value;
            };

            /**
             * [selectAlll 左侧全选]
             * @return {[type]} [description]
             */
            $scope.selectLeftAll = function() {
                if ($scope.data.Leftitems.length == 1 && $scope.data.Leftitems[0].OBJID == 0) {
                    $scope.data.Leftitems = $scope.data.selectLeftTemp;
                } else {
                    $scope.data.selectLeftTemp = angular.copy($scope.data.Leftitems);
                    $scope.data.Leftitems = [];
                    $scope.data.Leftitems.push({
                        'OBJTYPE': 0, // "111111",
                        'OBJID': 0, // $scope.info.GROUPID,
                        'OPERTYPE': 1,
                        'DESC': $scope.info.COMPANY
                    });
                    // $scope.info.DESC = $scope.info.DEPT;
                    // $scope.info.OBJID = $scope.info.GROUPID;
                    // $scope.data.Leftitems.push($scope.info);
                }
            };

            /**
             * [selectLeft 左侧选择按钮]
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.selectLeft = function(item) {
                var index = $scope.data.selectedLeftArray.indexOf(item);
                if (index < 0) {
                    $scope.data.selectedLeftArray.push(item);
                } else {
                    $scope.data.selectedLeftArray.splice(index, 1);
                }
            };

            /**
             * [addLeft description]左侧添加用户
             *
             * @return  {[type]}  [return description]
             */
            $scope.addLeft = function() {
                var tempLeftItems = angular.copy($scope.data.Leftitems);
                angular.forEach(tempLeftItems, function(value, key) {
                    value.DESC = value.OBJNAME || value.DESC;
                    value.OPERTYPE = value.OBJTYPE;
                    value.ID = value.OBJID;
                });
                trsTransferService.getDeptAndUser('', function(data) {
                    for (var item in data) {
                        data[item].OBJTYPE = data[item].OPERTYPE;
                        data[item].OBJID = data[item].ID;
                        data[item].OPERTYPE = 1;
                    }
                    $scope.data.Leftitems = data;
                    $scope.data.Leftitems = $filter('unique')($scope.data.Leftitems, 'ID');
                }, tempLeftItems, '添加可投稿人员范围');
                $scope.data.selectedLeftArray = [];
            };

            /**
             * [delLeft description]左侧 删除所选
             *
             * @param   {[type]}  index  [index description]
             *
             * @return  {[type]}         [return description]
             */
            $scope.delLeft = function(index) {
                // for (var item in $scope.data.selectedLeftArray) {
                //     var index = $scope.data.Leftitems.indexOf($scope.data.selectedLeftArray[item]);
                //     $scope.data.Leftitems.splice(index, 1);
                // }
                // $scope.data.selectedLeftArray = [];
                $scope.data.Leftitems.splice(index, 1);
            };

            /**
             * [delAllLeft 左侧 清空全部]
             * @return {[type]} [description]
             */
            $scope.delAllLeft = function() {
                $scope.data.Leftitems = $scope.data.selectedLeftArray = [];
            };

            /**
             * [selectRightAll 右侧 全选]
             * @return {[type]} [description]
             */
            $scope.selectRightAll = function() {
                // $scope.data.Rightitems.length == 1 && 
                if ($scope.data.Rightitems[0] && $scope.data.Rightitems[0].OBJID == 0) {
                    $scope.data.ownerTenantList = $scope.data.selectRightTemp;
                } else {
                    $scope.data.selectRightTemp = angular.copy($scope.data.ownerTenantList);
                    // $scope.data.Rightitems = [];
                    $scope.data.ownerTenantList = [{
                        'OBJTYPE': 0, // "222222",
                        'OBJID': 0, // $scope.info.GROUPID,
                        'OPERTYPE': 2,
                        'DESC': $scope.info.COMPANY
                    }];
                    // $scope.info.DESC = $scope.info.DEPT;
                    // $scope.info.OBJID = $scope.info.GROUPID;
                    // $scope.data.Rightitems.push($scope.info);
                }
                $scope.data.Rightitems = $scope.data.ownerTenantList.concat($scope.data.tenantList);
            };

            /**
             * [selectRight 右侧 选择按钮]
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.selectRight = function(item) {
                var index = $scope.data.selectedRightArray.indexOf(item);
                if (index < 0) {
                    $scope.data.selectedRightArray.push(item);
                } else {
                    $scope.data.selectedRightArray.splice(index, 1);
                }
            };

            /**
             * [addRight description]右侧 添加用户
             *
             * @return  {[type]}  [return description]
             */
            $scope.addRight = function() {
                var tempRightItems = angular.copy($scope.data.ownerTenantList);
                angular.forEach(tempRightItems, function(value, key) {
                    value.DESC = value.OBJNAME || value.DESC;
                    value.OPERTYPE = value.OBJTYPE;
                    value.ID = value.OBJID;
                });
                trsTransferService.getDeptAndUser('', function(data) {
                    for (var item in data) {
                        data[item].OBJTYPE = data[item].OPERTYPE;
                        data[item].OBJID = data[item].ID;
                        data[item].OPERTYPE = 2;
                    }
                    $scope.data.ownerTenantList = data;
                    $scope.data.Rightitems = $scope.data.ownerTenantList.concat($scope.data.tenantList);
                }, tempRightItems, '添加可见范围');
                $scope.data.selectedRightArray = [];
            };

            $scope.addTenant = function() {
                // var params = {
                //     CurrPage: 1,
                //     methodname:	'queryTenantsByCategory',
                //     PageSize: 100,
                //     serviceid: 'mlf_tenant'
                // };
                // $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                var options = {
                    selected: $scope.data.tenantList,
                    title: '添加可见范围'
                };
                trsTransferService.addTenant(options, function(data) {
                    var items = [];
                    data.forEach(function(item) {
                        items.push({
                            OBJNAME: item.TENANTNAME,
                            OBJTYPE: item.OBJTYPE,
                            OBJID: item.TENANTID,
                            OPERTYPE: 3
                        });
                    });
                    $scope.data.tenantList = items;
                    $scope.data.Rightitems = $scope.data.ownerTenantList.concat($scope.data.tenantList);
                });
                // });
            };

            /**
             * [delRight description]右侧 删除所选
             *
             * @param   {[type]}  index  [index description]
             *
             * @return  {[type]}         [return description]
             */
            $scope.delRight = function(index) {
                // for (var item in $scope.data.selectedRightArray) {
                //     var index = $scope.data.Rightitems.indexOf($scope.data.selectedRightArray[item]);
                //     $scope.data.Rightitems.splice(index, 1);
                // }
                // $scope.data.selectedRightArray = [];
                var arr = [];
                if ($scope.data.Rightitems[index].OPERTYPE < 3) {
                    arr = $scope.data.ownerTenantList;
                } else {
                    arr = $scope.data.tenantList;
                }
                for (var i = 0; i < arr.length; i++) {
                    if (arr[i].OBJID === $scope.data.Rightitems[index].OBJID) {
                        arr.splice(i, 1);
                        break;
                    }
                }
                $scope.data.Rightitems.splice(index, 1);
            };

            /**
             * [delAllRight 右侧 清空全部]
             * @return {[type]} [description]
             */
            $scope.delAllRight = function() {
                $scope.data.ownerTenantList = [];
                $scope.data.tenantList = [];
                $scope.data.Rightitems = $scope.data.selectedRightArray = [];
            };

            /**
             * [cancel description]取消
             *
             * @return  {[type]}  [return description]
             */
            $scope.cancel = function() {
                $scope.data.Leftitems = $scope.data.selectedLeftArray = [];
                $scope.data.Rightitems = $scope.data.selectedRightArray = [];
                $modalInstance.dismiss();
            };

            /**
             * [confirm description]确定
             *
             * @return  {[type]}  [return description]
             */
            $scope.confirm = function() {
                // 稿件可投稿人员范围或稿库可见范围 未选中 禁止提交
                if ($scope.data.Leftitems.length === 0) {
                    modalDialog.alertType($scope.title + '失败', '请选择稿件可投稿人员范围', 'error', false, function() {
                        return;
                    });
                } else if ($scope.data.Rightitems.length === 0) {
                    modalDialog.alertType($scope.title + '失败', '请选择稿库可见范围', 'error', false, function() {
                        return;
                    });
                } else {
                    $scope.Params.CORDER = $scope.data.sortWeiZhi.value; // 调整位置传的值
                    var VisibleCategorys = $scope.data.Leftitems.concat($scope.data.Rightitems); // 合并稿库为同一个数组
                    // 处理数组返回的格式
                    for (var item in VisibleCategorys) {
                        VisibleCategorys[item] = ({
                            OperType: VisibleCategorys[item].OPERTYPE,
                            ObjId: VisibleCategorys[item].OBJID,
                            ObjType: VisibleCategorys[item].OBJTYPE,
                        });
                    }
                    // 把数组转为字符串
                    $scope.Params.VISIBLECATEGORYS = JSON.stringify(VisibleCategorys);
                    $modalInstance.close($scope.Params);
                }
            };
        }
    ]);
